import React, { useState, useContext } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import 'bulma/css/bulma.min.css';

import { SampleConfigurationSet } from '../../sampleSets.ts';
import { BeamlineContext } from '../../beamlineProvider.tsx';
import { SampleSetsContext } from '../../sampleSetsProvider.tsx';


const DeleteSet: React.FC = () => {

  var { setSlug } = useParams();

  const beamlineContext = useContext(BeamlineContext);
  const sampleSetsContext = useContext(SampleSetsContext);
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [inProgress, setInProgress] = useState<boolean>(false);
  const [submitErrorMessage, setSubmitErrorMessage] = useState<string | null>(null);

  function getSet(): SampleConfigurationSet | undefined {
    if (!setSlug) { return undefined; }
    return sampleSetsContext.sets.getBySlug(setSlug);
  }

  function clickedOpen() {
    const thisSet = getSet();
    if (!inProgress && !isOpen && thisSet) {
      setIsOpen(true);
    }
  }

  async function pressedSubmit() {
    const thisSet = getSet();
    if (!thisSet) { return; }

    setSubmitErrorMessage(null);
    setInProgress(true);
    const result = await sampleSetsContext.sets.deleteSetFromServerAndRemove(thisSet.slug);
    sampleSetsContext.changed();
    setInProgress(false);
    if (!result.success) {
      setSubmitErrorMessage(result.message || "");
    } else {
      setIsOpen(false);
      navigate('../', { relative: "route" });
    }
  };

  function clickedClose() {
    if (!inProgress) { setSubmitErrorMessage(null); setIsOpen(false); }
  }

  return (
    <a className="dropdown-item" onClick={ clickedOpen }>Delete { beamlineContext.setNounCapitalized }

      <div id="modal-add-sample" className={ isOpen ? "modal is-active" : "modal" }>
        <div className="modal-background"></div>

        <div className="modal-card">
          <header className="modal-card-head">
            <p className="modal-card-title">Delete { beamlineContext.setNounCapitalized }</p>
            <button className="delete" aria-label="close" onClick={ clickedClose }></button>

          </header>
          <section className="modal-card-body">

            <div className="block">
              <p>
                Are you sure you want to delete { beamlineContext.setNoun } { getSet()?.name }?
              </p>
              <p>
                <b>This operation cannot be undone!</b>
              </p>
            </div>

            <div className="buttons">
              <input
                type="button"
                className="button is-danger"
                onClick={ pressedSubmit }
                disabled={ inProgress }
                value="Delete"
              />
              <button className="button" onClick={ clickedClose }>Cancel</button>
            </div>

            { submitErrorMessage && (
              <article className="message is-danger">
                <div className="message-body">
                  { submitErrorMessage }
                </div>
              </article>
            )}

          </section>

        </div>
      </div>

    </a>
  )
}
export default DeleteSet
